"use strict";
Object.defineProperty(exports, "__esModule", { value: true });
exports.flatMergeRecipe = void 0;
const merging_1 = require("../async-base/merging");
function flatMergeRecipe({ resolver, toArray }) {
    return function (callback) {
        return resolver(toArray.call(this), callback
            ? (x) => (0, merging_1.mergeIterables)(callback, ...x)
            : (x) => (0, merging_1.mergeIterables)(...x));
    };
}
exports.flatMergeRecipe = flatMergeRecipe;
